import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Router } from 'react-router-dom';
import { fetchCommonDetails } from '../actions/commonActions';
import { config } from '../env_config/react-config';
import App from './App';
import UnderMaintanance from '../components/common/UnderMaintanance';
import Loading from '../components/common/Loading';
import history from '../route/history';

class PublishStatus extends Component {
    componentDidMount(){
        this.props.fetchCommonDetails(config.retailerId);
    }

    render(){
        const { commonDetails, isCommonDetailsLoading } = this.props;
        return(
            <div>
                {
                    isCommonDetailsLoading &&
                    <div className="parent-loading-publish-status">
                        <Loading />
                    </div>
                }
                {
                    (!isCommonDetailsLoading && !commonDetails.error &&commonDetails.field_site_published_status === 'Off') ?
                    <UnderMaintanance /> :
                    <Router history={history}>
                        <App />
                    </Router>
                }
                {
                    !isCommonDetailsLoading && commonDetails.error &&
                    <div>Content Empty
                        </div>
                }
            </div>
        )
    }

}

const mapStateToProps = state => ({
    commonDetails: state.commonReducer.commonDetails,
    isCommonDetailsLoading: state.commonReducer.isCommonDetailsLoading
});

export const mapDispatchToProps = (dispatch) => ({
    fetchCommonDetails: (retailerId) => dispatch(fetchCommonDetails(retailerId))
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PublishStatus);